// const API_BASE_CRM_URL = "http://192.168.1.196:3008/accumen/";
// const API_BASE_CRM_URL = "http://localhost:3008/accumen/";
// const API_BASE_CRM_URL = "https://rs8qkwbd-3008.inc1.devtunnels.ms/accumen/";
const API_BASE_CRM_URL = "https://crmextapi.ibizaccounts.in/accumen/";
const Attachment_BASE_URL = "https://files-test.perennialdevelopers.in";

export { API_BASE_CRM_URL, Attachment_BASE_URL };
